module.exports = __webpack_public_path__ + "img/Crux.0573f53e.png";